import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled, { css } from 'styled-components';
import { isMobile } from './utils';
export default function Popup(props) {
    const ref = React.useRef(null);
    React.useEffect(() => {
        const onClick = (ev) => {
            var _a, _b;
            if (!((_a = ref.current) === null || _a === void 0 ? void 0 : _a.contains(ev === null || ev === void 0 ? void 0 : ev.target))) {
                (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props);
            }
        };
        window.addEventListener('click', onClick);
        return () => {
            window.removeEventListener('click', onClick);
        };
    });
    return (_jsx(Container, { ref: ref, className: `${props.className || ''} ui-popup`, isMobile: isMobile(), scrollable: Boolean(props.scrollable), above: props.showAbove, children: _jsx("div", { className: 'wrapper', children: props.children }) }));
}
const Container = styled.div `
  position: absolute;
  background-color: var(--ui-popup-bg);
  padding: 0.25em;
  border-radius: 0.5em;
  top: calc(100% + 0.125rem);
  left: 0;
  min-height: 2rem;
  width: 100%;
  max-width: 35rem;
  box-sizing: border-box;
  z-index: 777;
  box-shadow: var(--workspace-box-shadow);

  ${props => props.above && css `
    top: unset;
    bottom: calc(100% + 0.125rem);
  `}

  & > .wrapper {
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: none;

    ${props => props.scrollable && css `
      max-height: 15rem;
    `}

    ${props => props.isMobile && css `
      max-height: 9rem;
    `}

    scrollbar-width: thin;
    scrollbar-color: var(--ui-accent-color) transparent;

    &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background-color: transparent;
    }

    &::-webkit-scrollbar-thumb {
        background-color: var(--ui-accent-color);
        border: none;
    }
  }
`;
